export const generateICSFile = ({
  title,
  description,
  location,
  start,
  end,
  recurrence,
}) => {
  const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${title}
DTSTART:${start}
DTEND:${end}
${recurrence ? `RRULE:${recurrence}` : ""}
DESCRIPTION:${description}
LOCATION:${location}
END:VEVENT
END:VCALENDAR
  `.trim();

  const blob = new Blob([icsContent], {
    type: "text/calendar;charset=utf-8",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "event.ics");

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};

export const formatGoogleDateTime = (date, time) => {
  const utcDate = new Date(`${date}T${time}Z`);

  return utcDate.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
};
